import { FormConfig } from "../../types/form";
import { Roles } from "../../constants/user";
import { queryBannerFields } from "../fields";

export const emailPagesForm = (userRoles: Roles): FormConfig => ({
  fields: [
    queryBannerFields.emailAddress,
    queryBannerFields.emailType,
    queryBannerFields.fromDate,
    queryBannerFields.toDate,
  ],
});
